export default ['$rootScope', Root]

// this component loads first, it should be responsible
// for all data loading via router resolve
// then all data can flow down, or we can put it all in rootscope

function Root($rootScope) {
  if (window) {
    window.dispatch = (action) => $rootScope.$broadcast('DISPATCH', action)
  }
}
